import React from "react";
import { Link } from "react-router-dom";
import ViewActionButton from "./table/ViewActionButton";

// Table Component from Dashboad page and student page
export function Table({ user }) {
  return (
    <>
      <tr className="text-black shadow-sm text-sm rounded-lg   leading-8 items-center">
        <td className=" flex gap-2 px-2 items-center">
          <img
            className=" w-6 rounded-full h-6"
            src={user.image}
            alt="userImage"
          />
          <td className="py-2 px-4">{user.name}</td>
        </td>
        <td className="py-2 px-4">{user.emailAddress}</td>
        <td className="py-2 px-4">{user.phoneNumber}</td>
        <td className="py-2 px-4">{user.dateJoined}</td>
        <td className="py-2 px-4">
          <Link to="/student/user-details">
            <button className="text-sm text-[#1234CD] font-bold ">
              {user.action}
            </button>
          </Link>
        </td>
      </tr>
    </>
  );
}

// export function Table({ user }) {
//   return (
//     <tr className="text-black text-sm border-b last:border-b-0">
//       {/* Name + Image */}
//       <td className="px-4 py-3">
//         <div className="flex items-center gap-2 min-w-[180px]">
//           <img
//             className="w-6 h-6 rounded-full"
//             src={user.image}
//             alt="user"
//           />
//           <span className="whitespace-nowrap">{user.name}</span>
//         </div>
//       </td>

//       {/* Email */}
//       <td className="px-4 py-3 min-w-[220px]">
//         <span className="truncate block">{user.emailAddress}</span>
//       </td>

//       {/* Phone */}
//       <td className="px-4 py-3 min-w-[150px]">{user.phoneNumber}</td>

//       {/* Date */}
//       <td className="px-4 py-3 min-w-[140px]">{user.dateJoined}</td>

//       {/* Action */}
//       <td className="px-4 py-3 min-w-[120px]">
//         <Link to="/student/user-details">
//           <button className="text-[#1234CD] font-semibold">
//             {user.action}
//           </button>
//         </Link>
//       </td>
//     </tr>
//   );
// }

// Category of Table Component from lesson page
export function TableCategory({ categories }) {
  return (
    <table className="min-w-full bg-white mt-10">
      <thead>
        <tr>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Name
          </th>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Date Created
          </th>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {categories.map((category, index) => (
          <tr
            key={index}
            className={`${index === categories.length - 1 ? "last-row" : ""}`}
          >
            <td className="py-4 px-4">{category.name}</td>
            <td className="py-4 px-4 w-[80%]">{category.dateCreated}</td>
            <td className="py-4 px-4 text-[#1233CC] font-semibold cursor-pointer hover:underline">
              View details
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export const TableClassroom = ({
  data,
  searchTerm,
  selectedRow,
  setSelectedRow,
  onViewDetails,
}) => {
  const filteredData = data.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.date.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <table className="min-w-full bg-white">
      <thead>
        <tr>
          <th className="text-left py-3 px-2 uppercase font-semibold text-sm">
            Name
          </th>
          <th className="text-left py-3 px-2 uppercase font-semibold text-sm">
            Date Created
          </th>
          <th className="text-left py-3 px-2 uppercase font-semibold text-sm">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {filteredData.map((item, index) => (
          <TableRow
            key={index}
            item={item}
            isSelected={selectedRow === index}
            onClick={() => setSelectedRow(index)}
            onViewDetails={onViewDetails}
          />
        ))}
      </tbody>
    </table>
  );
};

export const TableRow = ({ item, onViewDetails, onClick }) => (
  <tr
    className={``}
    onClick={onClick}
  >
    <td className="py-3 px-2  text-[14px]">{item.name}</td>
    <td className="py-3 px-2 w-[70%] text-[14px]">{item.date}</td>
    <td className="py-3 px-2 text-purple-600 cursor-pointer  text-[14px] font-semibold">
      <button onClick={onViewDetails}>View Details</button>
    </td>
  </tr>
);

// export const EmployeeTable = ({ mode, data, onView }) => {
//   const isOffboarding = mode === "offboarding";
//   return (
//     <table className=" lg:w-full mb-4 text-left">
//       <thead>
//         <tr className=" capitalize text-[#00000066] leading-4 pl-4  mb-4 text-sm">
//           {isOffboarding ? (
//             <>
//               <th>Resignee</th>
//               <th>Notice period</th>
//               <th>Tools Assigned</th>
//               <th>Date Joined</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </>
//           ) : (
//             <>
//               <th>Name</th>
//               <th>Employee ID</th>
//               <th>Phone number</th>
//               <th>Email address</th>
//               <th>Department</th>
//               <th>Actions</th>
//             </>
//           )}
//         </tr>
//       </thead>
//       <tbody className=" bg-white rounded-lg mb-4">
//         {data.map((item, index) => (
//           <tr
//             key={index}
//             className="shadow-sm text-sm my-4 leading-8"
//           >
//             {/* Common image + name cell */}
//             <td className="flex items-center space-x-2 py-2 pl-4">
//               <img
//                 src={item.image}
//                 alt="img"
//                 className="w-6 h-6 rounded-full"
//               />
//               <span>{item.name}</span>
//             </td>

//             {/* Dynamic columns */}
//             {isOffboarding ? (
//               <>
//                 <td className="py-2 px-4">{item.noticePeriod}</td>
//                 <td className="py-2 px-4">{item.toolsAssigned}</td>
//                 <td className="py-2 px-4">{item.dateJoined}</td>
//                 <td className="py-2 px-4">
//                   <span
//                     className={`font-medium ${
//                       item.status === "Approved"
//                         ? "text-green-500"
//                         : item.status === "Rejected"
//                         ? "text-red-500"
//                         : "text-yellow-500"
//                     }`}
//                   >
//                     {item.status}
//                   </span>
//                 </td>
//               </>
//             ) : (
//               <>
//                 <td className="py-2 px-4">{item.idNo}</td>
//                 <td className="py-2 px-4">{item.phoneNumber}</td>
//                 <td className="py-2 px-4">{item.emailaddress}</td>
//                 <td className="py-2 px-4">{item.department}</td>
//               </>
//             )}

//             {/* Actions */}
//             <td className="py-2 px-4">
//               <button
//                 onClick={() => onView(item)}
//                 className="text-[#3C60FF] font-[500]"
//               >
//                 {isOffboarding ? "View details" : "View employee"}
//               </button>
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

export const EmployeeTable = ({ mode, data, onView }) => {
  const isOffboarding = mode === "offboarding";
  return (
    <div className="w-full min-w-0 max-w-full overflow-x-auto overscroll-x-contain rounded-xl border border-slate-100 bg-white shadow-sm">
      <table className="w-full min-w-[740px] text-left md:min-w-[900px]">
        <thead>
          <tr className="bg-slate-50 text-sm capitalize text-black">
            {isOffboarding ? (
              <>
                <th className="py-2 px-4">Resignee</th>
                <th className="py-2 px-4">Notice period</th>
                <th className="py-2 px-4">Tools Assigned</th>
                <th className="py-2 px-4">Date Joined</th>
                <th className="py-2 px-4">Status</th>
                <th className="w-14 px-2 py-2 text-center sm:w-16">Actions</th>
              </>
            ) : (
              <>
                <th className="py-2 px-4">Name</th>
                <th className="py-2 px-4">Employee ID</th>
                <th className="py-2 px-4">Phone number</th>
                <th className="py-2 px-4">Email address</th>
                <th className="py-2 px-4">Department</th>
                <th className="w-14 px-2 py-2 text-center sm:w-16">Actions</th>
              </>
            )}
          </tr>
        </thead>
        <tbody className="bg-white rounded-lg mb-8">
          {data.map((item, index) => (
            <tr
              key={index}
              className="border-t border-slate-100 text-sm transition-colors hover:bg-slate-50"
            >
              <td className="flex min-w-[140px] items-center space-x-2 py-3 pl-3 pr-2 sm:pl-4">
                <img
                  src={item.image}
                  alt="img"
                  className="w-6 h-6 rounded-full"
                />
                <span>{item.name}</span>
              </td>

              {isOffboarding ? (
                <>
                  <td className="px-3 py-3 sm:px-4">{item.noticePeriod}</td>
                  <td className="px-3 py-3 sm:px-4">{item.toolsAssigned}</td>
                  <td className="px-3 py-3 sm:px-4">{item.dateJoined}</td>
                  <td className="px-3 py-3 sm:px-4">
                    <span
                      className={`font-medium ${
                        item.status === "Approved"
                          ? "text-green-500"
                          : item.status === "Rejected"
                            ? "text-red-500"
                            : "text-yellow-500"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                </>
              ) : (
                <>
                  <td className="min-w-[100px] px-3 py-3 sm:px-4">{item.idNo}</td>
                  <td className="min-w-[125px] px-3 py-3 sm:px-4">{item.phoneNumber}</td>
                  <td className="min-w-[180px] px-3 py-3 sm:px-4">{item.emailaddress}</td>
                  <td className="min-w-[180px] max-w-[360px] px-3 py-3 sm:px-4">
                    <span className="block truncate whitespace-nowrap leading-6" title={item.department || ""}>
                      {item.department || "—"}
                    </span>
                  </td>
                </>
              )}

              <td className="w-14 px-2 py-2 text-center sm:w-16">
                <ViewActionButton
                  onClick={() => onView(item)}
                  label={`${isOffboarding ? "View details for" : "View employee"} ${item.name || "employee"}`}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export function CandidatesTable({ candidate }) {
  return (
    <>
      <tr className="text-black text-sm items-center">
        <td className=" flex gap-2 px-2 items-center">
          <img
            className=" w-6 rounded-full h-6"
            src={candidate.image}
            alt="candidateImage"
          />
          <td className="py-4 px-4">{candidate.name}</td>
        </td>
        <td className="py-4 px-4">{candidate.department}</td>
        <td className="py-4 px-4">{candidate.emailaddress}</td>
        <td className="py-4 px-4">{candidate.stagesPassed}</td>
        <td className="py-4 px-4"> {candidate.dateApplied} </td>

        <td className="py-4 px-4">
          <Link to="/student/candidate-details">
            <button className="text-sm text-[#1234CD] font-[500]">
              {candidate.action}
            </button>
          </Link>
        </td>
      </tr>
    </>
  );
}
export function RecruitmentTable({ candidate }) {
  return (
    <>
      <tr className="text-black text-base items-center">
        <td className=" flex gap-2 px-2 items-center">
          <img
            className=" w-6 rounded-full h-6"
            src={candidate.image}
            alt="candidateImage"
          />
          <td className="py-4 px-4">{candidate.name}</td>
        </td>
        <td className="py-4 px-4">{candidate.department}</td>
        <td className="py-4 px-4">{candidate.emailaddress}</td>
        <td className="py-4 px-4">{candidate.stagesPassed}</td>
        <td className="py-4 px-4"> {candidate.dateApplied} </td>

        <td className="py-4 px-4">
          <Link to="/recruitement/candidate-details">
            <button className="text-base text-[#1234CD] font-[500]">
              {candidate.action}
            </button>
          </Link>
        </td>
      </tr>
    </>
  );
}
